import { useState, useEffect } from "react";

const useDeadline = (date_submitted, submission_deadline) => {
    const [isDeadlinePassed, setDeadlinePassed] = useState(false);
    const [isLockPresentationVideo, setLockPresentationVideo] = useState(false);

    const gracePeriod = parseInt(process.env.REACT_APP_GRACE_PERIOD);

    useEffect(() => {
        if (submission_deadline) {
            const dtsubmitted = new Date(date_submitted);
            const sbdeadline = new Date(submission_deadline);
            const today = new Date();

            // Check if submission was late
            if (today > sbdeadline) {
                setDeadlinePassed(true);
            }

            // Lock presentation video if grace period days have passed after the deadline
            // const deadlineDate = new Date(submission_deadline);
            
            const gracePeriodEndDate = new Date(sbdeadline);
            gracePeriodEndDate.setDate(sbdeadline.getDate() + gracePeriod);

            setLockPresentationVideo(today > gracePeriodEndDate);
        }
    }, [date_submitted, submission_deadline, gracePeriod]);

    return { isDeadlinePassed, isLockPresentationVideo };
};

export default useDeadline;